import { useEffect, useState } from "react";
import { usePreviewTemplate } from "../api/queries";
import type { TemplateKind } from "../api/types";

type Props = {
  kind: TemplateKind;
  content: string;
};

export function TemplatePreviewPane({ kind, content }: Props) {
  const preview = usePreviewTemplate();
  const [rendered, setRendered] = useState("");

  useEffect(() => {
    const handle = window.setTimeout(() => {
      preview.mutate(
        { kind, content },
        {
          onSuccess: (res) => setRendered(res.rendered),
        },
      );
    }, 350);
    return () => window.clearTimeout(handle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kind, content]);

  return (
    <div className="overflow-hidden rounded-xl border bg-muted/30">
      <div className="border-b bg-background/80 px-4 py-2.5">
        <p className="font-medium text-muted-foreground text-xs">
          ຕົວຢ່າງຂໍ້ຄວາມ Messenger
        </p>
      </div>
      <div className="min-h-[280px] bg-gradient-to-b from-muted/20 to-muted/50 p-4">
        <div className="ml-auto max-w-[95%] rounded-2xl rounded-tr-md border border-primary/20 bg-primary px-4 py-3 text-primary-foreground shadow-sm">
          <pre className="whitespace-pre-wrap font-sans text-sm leading-relaxed break-words">
            {rendered || "ກຳລັງສ້າງ preview…"}
          </pre>
        </div>
      </div>
    </div>
  );
}
